export default __webpack_public_path__ + "media/images/images_v2/bandebleue-aba7fe2388e33b697cfae8afac77918c.png";